import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Seo from '../components/Seo';

const PLAY_URL = {
  rider: 'https://play.google.com/store/apps/details?id=com.elt.totowala',
  driver: 'https://play.google.com/store/apps/details?id=com.elt.totowalafordrivers',
};

// Reached only when the app is not installed or the App Link did not verify.
// app: 'rider' for /r/<id> links, 'driver' for /d/<id> links.
const CampaignRedirect = ({ app }) => {
  const { campaignId } = useParams();
  const playUrl = PLAY_URL[app];

  useEffect(() => {
    const valid = /^[A-Za-z0-9_-]{1,36}$/.test(campaignId ?? '');
    const referrer = valid ? `&referrer=${encodeURIComponent(`utm_campaign=${campaignId}`)}` : '';
    window.location.replace(playUrl + referrer);
  }, [campaignId, playUrl]);

  return (
    <>
      <Seo title="TotoWala" description="Opening TotoWala" noIndex={true} />
      <p className="p-8 text-center">
        <a href={playUrl} className="text-primary underline">Open TotoWala on Google Play</a>
      </p>
    </>
  );
};

export default CampaignRedirect;
